<template>
    <div id="content" class="w">
        <div class="lg_box">
            <img src="../../assets/picture/login_bg.jpg" width="410" height="490" class="lf_bg">
            <img src="../../assets/picture/login_rma.png" width="80" height="80" class="lf_rm" id="lf_rm" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)">
            <img src="../../assets/picture/minapp_qw.png" width="200" height="228" class="lf_rmb hid" id="lf_rmb" :style="active">

            <div id="logbox" v-show="showLogin">
                <h1 class="lh1 yahei" id="lh1">注册账号</h1>
                <div id="phone_login" class="logx">
                    <form action="" method="post">
                        <div class="llabel">
                            <em class="ll_left yahei">手机号:</em>
                            <input type="text" name="mobile" id="mobile" class="llpt" value="" maxlength="11" placeholder="输入11位手机号">
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">验证码:</em>
                            <input type="number" name="code" id="code" class="llpt" value="" maxlength="6" placeholder="输入验证码">
                            <input type="button" value="获取短信验证码" id="dx" class="dxm">
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">昵称:</em>
                            <input type="text" name="nickname" id="nickname" class="llpt" value="" maxlength="20" placeholder="请输入用户昵称">
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">密码:</em>
                            <input type="text" name="password" id="password" class="llpt" value="" maxlength="6" placeholder="密码长度6位，且同时包含字母和数字">
                        </div>
                        <div class="llabel">
                            <em class="ll_left yahei">邀请码:</em>
                            <input type="text" name="share" id="share" class="llpt" value="" maxlength="20" placeholder="请输入邀请码，获得更多优惠">
                        </div>
                        <p @click="submitf()" class="log_btn yahei" id="log_btn">注册</p>
                    </form>
                </div>
                <div id="phone_login" class="logx" style="padding-top:0;">
                    <div class="alC">
                        <a href="javascript:;" class="ck_a">返回</a>
                        <a href="javascript:;" @click="login()" class="ck_a">帐号密码登录</a>
                        <a href="javascript:;" class="ck_a">回首页</a>
                    </div>
                </div>
            </div>
            <p class="fuwu">
                登录代表同意夜樱情趣 
                <a href="javascript:;" class="U">服务协议</a>
                <a href="javascript:;" class="U">法律声明</a>
                <a href="javascript:;" class="U">隐私政策权</a>
            </p>
            <div class="hid" id="loginscuess">
                <div class="lgxx">
                    <img src="../../assets/picture/bigyes.png" width="60" height="60">
                    <h2 class="f16 yahei" style="color:#0ba816;margin-top:20px;" id="tishi">恭喜，登录成功</h2>
                    <p id="miaod"><b id="tims">5</b>秒后自动返回到上一页</p>
                    <p>&nbsp;</p>
                    <div class="f0">
                        <a href="javascript:;" class="lg_btn">进入会员中心</a>
                        <a href="javascript:;" class="lg_btn lg_btnr">返回上一页</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            active: "",
        }
    },
    methods:{
        login(){
            //指定跳转地址
			this.$router.replace('/login')
        },
        onMouseOver($event){
            this.active="display:inline"
        },
        onMouseOut($event){
            this.active="display:none"
        },
        submitf(){

        }
    }
}
</script>

<style scoped>
.lg_box{border:1px solid #f1f1f1;position:relative;padding:0 0 0 500px;/*height:490px;*/overflow:hidden;box-shadow:0px 3px 10px #f1f1f1;background-color:#fff;margin: 70px 0 120px 0;}
.lf_bg{position:absolute;left:0;top:0;}
.lh1{font-size:35px;color:#000;line-height:45px;margin:40px 40px 0 0;}
.logx{padding:20px 0 0 0;width:400px;}
.llabel{line-height:60px;height:60px;position:relative;border:1px solid #f0f0f0;padding:0 0 0 75px;border-radius:4px;margin-bottom:10px;overflow:hidden;}
.ll_left{position:absolute;left:15px;top:0;line-height:60px;font-size:16px;color:#333;}
.llpt{width:100%;height:60px;border:0;color:#000;font-size:16px;line-height:60px;vertical-align:top;}
.dxm{position:absolute;color:#6b73f7;right:0;top:0;border:0;background-color:#fff;height:60px;border-left:1px solid #f0f0f0;width:130px;text-align:center;cursor:pointer;}
.log_btn{background-color:#4c62fc;color:#fff;line-height:60px;border-radius:8px;text-align:center;font-size:18px;margin:40px 0 30px 0;border:none;box-shadow:0px 1px 8px #7a89f2;cursor:pointer;}
.fuwu{text-align:center;font-size:12px;color:#ccc;line-height:60px;width:60%;}
.U{color:#ccc;padding:0 4px;}
.ck_a{color:#999;line-height:34px;display:inline-block;margin:0 5px;border:1px solid #f1f1f1;border-radius:20px;padding:0 14px;*display:inline;zoom:1;}
.lgxx{text-align:center;line-height:30px;margin:90px 0 0 20px;width:60%;}
.f0{font-size:0px;text-align:center;}
.lg_btn{background-color:#e0e1e3;border-radius:8px;line-height:50px;text-align:center;width:40%;color:#888;display:inline-block;margin:0 10px;font-size:14px;}
.lg_btnr{background-color:#4c62fc;color:#fff;}
.fb_d{border-color:#fff;}
.lf_rm,.lf_rmb{position:absolute;right:0;top:0;z-index:1;}
.lf_rmb{z-index:2;}
</style>


// WEBPACK FOOTER //
// src/components/register/Index.vue